module.exports = __webpack_public_path__ + "assets/img/addPatient-banner.0e17a795.png";